import React from 'react'
import * as Styled from './styled'

interface Props {
  onClickReview: () => void
  id: string
}

export const Validator: React.FunctionComponent<Props> = ({ onClickReview, id }) => {
  return (
    <Styled.Container>
      <Styled.AlertContainer>
        <Styled.ExclamationPoint
          name="exclamationPoint"
          title={`exclamationPoint-${id}`}
        />
        <Styled.Text data-test="review-bibliography-citation" onClick={onClickReview}>
          Your citation may be missing information
        </Styled.Text>
      </Styled.AlertContainer>
    </Styled.Container>
  )
}

export default Validator
